import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-accounting-information',
  templateUrl: './accounting-information.component.html',
  styleUrl: './accounting-information.component.scss'
})
export class AccountingInformationComponent {
  @Input() accountingInformation = null;
  @Input() formAmount = null;
  @Input() rangeSales = null;
  @Input() yearNow = null;
  @Input() annualSaleYear1 = null;
  @Input() annualSaleAmount1USD = null;
  @Input() annualSaleYear2 = null;
  @Input() annualSaleAmount2USD = null;
  @Input() annualSaleYear3 = null;
  @Input() annualSaleAmount3USD = null;
}
